import { render, staticRenderFns } from "./RollHistoryElement.vue?vue&type=template&id=42915168&scoped=true"
import script from "./RollHistoryElement.vue?vue&type=script&lang=js"
export * from "./RollHistoryElement.vue?vue&type=script&lang=js"
import style0 from "./RollHistoryElement.vue?vue&type=style&index=0&id=42915168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42915168",
  null
  
)

export default component.exports